import { index, sqliteTable, text } from 'drizzle-orm/sqlite-core'

import { id, timestamps } from './_columns'
import { sites } from './sites'

/**
 * What a client asked for from its CMS and staff handle in the console: help connecting a domain, or a change of the
 * mail domain. Created through the signed site hook (`POST /api/hooks/domains`), closed by staff as done or rejected.
 */
export const siteRequests = sqliteTable(
  'site_requests',
  {
    id: id(),
    siteId: text('site_id')
      .notNull()
      .references(() => sites.id, { onDelete: 'cascade' }),
    kind: text('kind').$type<'domain_help' | 'mail_domain_change'>().notNull(),
    status: text('status').$type<'open' | 'done' | 'rejected'>().notNull().default('open'),
    /** The client's own words. */
    note: text('note').notNull().default(''),
    /** The domain the request is about, when the client named one. */
    domain: text('domain'),
    /** Who sent it from the CMS ("Name <email>"), as the site reported it. */
    requestedBy: text('requested_by').notNull().default(''),
    /** Staff's answer, shown to the client. */
    staffNote: text('staff_note').notNull().default(''),
    resolvedBy: text('resolved_by'),
    resolvedAt: text('resolved_at'),
    ...timestamps,
  },
  (t) => [index('ix_site_requests_site').on(t.siteId, t.createdAt), index('ix_site_requests_status').on(t.status, t.createdAt)],
)

export type SiteRequestRow = typeof siteRequests.$inferSelect
